export default __webpack_public_path__ + "static/media/benefit-2@2x.c0395746.png";